/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './pin-transfer-list.scss';
import { FormattedMessage } from 'react-intl';
import ListViewShowMore from '../../../../sharedmodules/components/list-view-show-more';
import PropTypes from 'prop-types';
import React from 'react';
import Transfer from '../state/dealerTransferResponse';
import TransferSearchResult from './transfer-search-result';

const PinTransferList = (props) => {

    let list;

    if (props.transfers[0].currentDealer.account !== '') {

        const transfers = props.transfers.map((transfer) => (
            <TransferSearchResult
                actions={props.actions}
                auth={props.auth}
                key={transfer.id}
                transfer={transfer}
            />
        ));

        list = (
            <ListViewShowMore
                initialShowItems={50}
                perMoreMultiplier={1.25}
                showAllOption
                showPerMore={50}
                totalItems={props.transfers.length}
            >
                {transfers}
            </ListViewShowMore>
        );

    } else {

        list = <span className="empty"><FormattedMessage id="NO_RESULTS_FOUND" /></span>;

    }

    return (
        <div className="product-list">
            <div className="list-header">
                {props.children}
            </div>
            {list}
        </div>
    );

};

PinTransferList.displayName = 'PinTransferList';
PinTransferList.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    children: PropTypes.node,
    transfers: PropTypes.arrayOf(PropTypes.instanceOf(Transfer)).isRequired,
    updateCommentAction: PropTypes.func,
    updateStatusAction: PropTypes.func,
};

export default PinTransferList;
